/**
 * @generated SignedSource<<1903c656c21e96e8ded0d62825d9d7ad>>
 * @relayHash 338f28b041520a3caa75f9f8aad90e3e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID eaeb766594d01e4f6ecd688b983d57cf252776b7f80ee703dad9ca8f1e81c958

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraVersionUpdateApproverDeclineReasonInput = {
  approverId: string;
  reason?: string | null | undefined;
};
export type declineReason_softwareReleasesApproversMutation$variables = {
  input: JiraVersionUpdateApproverDeclineReasonInput;
};
export type declineReason_softwareReleasesApproversMutation$data = {
  readonly jira: {
    readonly updateJiraVersionApproverDeclineReason: {
      readonly approver: {
        readonly declineReason: string | null | undefined;
        readonly id: string;
      } | null | undefined;
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type declineReason_softwareReleasesApproversMutation$rawResponse = {
  readonly jira: {
    readonly updateJiraVersionApproverDeclineReason: {
      readonly approver: {
        readonly declineReason: string | null | undefined;
        readonly id: string;
      } | null | undefined;
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type declineReason_softwareReleasesApproversMutation = {
  rawResponse: declineReason_softwareReleasesApproversMutation$rawResponse;
  response: declineReason_softwareReleasesApproversMutation$data;
  variables: declineReason_softwareReleasesApproversMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "JiraVersionUpdateApproverDeclineReasonPayload",
        "kind": "LinkedField",
        "name": "updateJiraVersionApproverDeclineReason",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "JiraVersionApprover",
            "kind": "LinkedField",
            "name": "approver",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "declineReason"
              }
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "declineReason_softwareReleasesApproversMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "declineReason_softwareReleasesApproversMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "eaeb766594d01e4f6ecd688b983d57cf252776b7f80ee703dad9ca8f1e81c958",
    "metadata": {},
    "name": "declineReason_softwareReleasesApproversMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "8a8bd7229f8a09992db859a1ce22ddb1";

export default node;
